import { useMemo, useEffect } from "react"
import { node } from "prop-types"
import { Route, Routes } from "react-router-dom"
import { StreamChat } from "stream-chat"
import { Chat } from "stream-chat-react"
import { useApiRead } from "source/shared/SessionApiResource"
import TabView from "source/groups/my/groups/TabView"
import { ConversationsIndex } from "source/groups/my/groups/conversations/index"
import { ConversationsShow } from "source/groups/my/groups/conversations/show"
import { ConversationsNew } from "source/groups/my/groups/conversations/new"
import { ConversationsEdit } from "source/groups/my/groups/conversations/edit"

export default function ConversationsRouter() {
  return (
    <TabView>
      <StreamChatProvider>
        <Routes>
          <Route path="/" element={<ConversationsIndex />} />
          <Route path="/:conversationId" element={<ConversationsShow />} />
          <Route path="/:conversationId/edit" element={<ConversationsEdit />} />
          <Route path="/new" element={<ConversationsNew />} />
        </Routes>
      </StreamChatProvider>
    </TabView>
  )
}

StreamChatProvider.propTypes = {
  children: node.isRequired,
}

export function StreamChatProvider({ children }) {
  const { apiKey, token, userId } = useMyStreamCredentials()
  const client = useMemo(() => new StreamChat(apiKey), [apiKey])

  useEffect(() => {
    if (!client.userID) client.connectUser({ id: userId }, token)
    return () => client.disconnectUser()
  }, [client, userId, token])

  return <Chat client={client}>{children}</Chat>
}

function useMyStreamCredentials() {
  const { data: user } = useApiRead(`/chat/v2/me/stream_user`, {
    headers: { "X-PCO-Groups-Chat": 1 },
  })
  const apiKey = user.attributes.api_key
  const token = user.attributes.token
  const userId = user.id

  return { apiKey, token, userId }
}
